let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j0btO")).then(() => parcelRequire('4I7v4'));